/**
 * オーナー専用画面（請求・利用状況）のアクセス判定。
 *
 * 出所は /auth/me の company.account_role（"member" | "admin" | "owner"）。
 * 請求・利用状況は会社の契約金額を扱うため、オーナーだけが閲覧できる。
 */

export const OWNER_ROLE = "owner";

/** オーナー専用画面を閲覧できるか（ロール未取得は不可） */
export const canAccessOwnerOnly = (accountRole: string | null): boolean =>
  accountRole === OWNER_ROLE;
